// Genererad av Areas/BreaksCampaign/Frontend/tools/sweden-map från SCB:s Digitala gränser (CC0). Ändra inte för hand.
export const viewBox = "0 0 660 1555";

export const outlinePath =
  "M416 1086L439 1069L461 1034L447 1021L443 1002L427 1005L430 984L418 984L403 974L391 957L375 958L361 952L349 919L349 908L347 892L352 881L345 867L344 853L358 828L354 817L361 786L369 774L355 746L374 744L389 732L386 713L404 706L412 689L409 679L438 659L445 633L468 624L480 609L499 605L514 583L522 551L533 535L548 516L531 499L528 467L537 445L540 408L552 406L570 389L566 355L580 362L607 354L624 354L649 350L631 312L618 297L617 280L625 266L620 229L602 202L607 173L591 168L595 152L589 130L593 114L575 95L564 79L492 44L491 37L464 10L436 12L446 25L444 52L434 66L446 71L434 87L395 74L379 77L371 70L359 75L363 114L355 135L328 123L306 144L297 179L280 200L294 228L292 244L276 260L260 292L249 305L253 319L254 326L231 342L211 343L216 379L209 419L209 435L201 455L168 515L188 527L190 536L191 559L181 580L148 571L128 574L117 583L90 625L93 638L80 660L90 690L84 700L86 718L81 732L92 772L82 832L96 850L104 850L118 874L107 907L83 911L90 941L101 967L94 988L94 1010L90 1020L73 1035L57 1040L60 1054L46 1068L51 1108L39 1143L28 1144L24 1121L10 1131L12 1151L18 1192L22 1203L31 1210L31 1213L25 1222L33 1217L41 1211L51 1223L49 1228L42 1249L44 1269L39 1279L50 1295L51 1317L62 1324L59 1333L72 1359L71 1365L87 1383L93 1399L106 1410L103 1421L94 1434L95 1446L94 1446L82 1454L93 1475L102 1490L106 1501L110 1510L110 1511L102 1526L106 1538L127 1545L136 1540L147 1536L164 1534L182 1539L192 1523L182 1499L183 1491L199 1469L204 1467L212 1455L236 1452L252 1457L263 1453L275 1451L285 1463L297 1436L301 1420L315 1396L320 1373L323 1345L321 1328L333 1306L327 1296L333 1276L323 1266L337 1257L336 1248L339 1227L331 1219L342 1212L324 1200L343 1192L334 1178L346 1172L353 1168L373 1160L383 1146L386 1120L391 1125L404 1130L421 1124L425 1114L418 1105L409 1099L406 1093L408 1088L410 1084L414 1087L416 1086ZM362 1107L336 1084L329 1086L302 1089L292 1085L302 1082L314 1083L340 1074L366 1068L377 1073L391 1083L391 1092L402 1096L396 1105L397 1108L388 1107L381 1107L370 1109L362 1107ZM276 1122L267 1102L281 1105L293 1111L283 1119L276 1122ZM205 1238L190 1261L180 1262L186 1233L197 1205L206 1180L216 1172L229 1172L230 1192L211 1211L205 1238ZM104 1129L122 1134L130 1129L124 1109L127 1098L143 1100L153 1098L169 1100L179 1113L172 1127L181 1134L175 1150L169 1158L155 1158L152 1172L136 1180L130 1193L123 1170L109 1192L94 1203L88 1187L91 1157L104 1129ZM214 935L218 923L231 929L235 933L214 935ZM212 669L204 678L206 692L200 685L182 657L212 669ZM336 1396L344 1378L330 1373L325 1386L317 1407L328 1426L336 1396ZM439 1263L417 1299L421 1338L437 1341L453 1329L456 1313L458 1271L475 1258L452 1252L439 1263ZM46 1232L44 1217L21 1227L30 1236L46 1232Z";

/** Gränser mellan län, utan kustlinjen. */
export const countyBorderPath =
  "M383 1146L368 1137L364 1121L361 1115L362 1107M377 1073L378 1063L380 1058L406 1053L421 1037L420 1017L427 1005M340 1074L330 1050L335 1041L326 1025L328 1004M328 1004L338 994L354 991L359 973L361 952M268 1138L276 1122M281 1105L289 1096L302 1089M334 1178L311 1170L304 1157L299 1154L287 1142L268 1138M257 1283L238 1277L231 1257L234 1246L228 1235L209 1240L205 1238M229 1172L246 1152L252 1156L256 1157L263 1145L268 1138M336 1248L313 1232L291 1240L295 1264L287 1270L272 1265L264 1272L257 1283M257 1283L271 1293L267 1299L260 1332L264 1339M264 1339L255 1335L236 1340L219 1335L201 1344L195 1344L189 1374L180 1356L156 1353L152 1362M152 1362L139 1348L116 1349L119 1343M119 1343L129 1326L153 1298L155 1282L157 1267L156 1256L160 1244L171 1248L180 1233L186 1233M264 1339L277 1353L281 1370L263 1372L266 1379L254 1386L254 1405L253 1418M253 1418L233 1421L227 1430L212 1428L207 1422L203 1421M203 1421L179 1416L152 1424L144 1426L137 1424M137 1424L134 1403L130 1394L128 1377L151 1371L152 1362M297 1436L285 1437L273 1423L262 1419L253 1418M204 1467L206 1450L197 1447L196 1438L203 1421M103 1421L105 1430L121 1435L137 1424M50 1295L53 1295L70 1291L75 1320L99 1327L119 1343M51 1108L74 1105L87 1120L97 1114L104 1129M181 1134L190 1138M190 1138L193 1157L198 1161L214 1167L216 1172M107 907L108 913L133 941L134 948L153 979L160 980L175 1006L174 997L184 1000L189 1016L201 1024M201 1024L202 1073L202 1079L193 1102L193 1104L190 1138M201 1024L218 1027L239 1024L244 1028L255 1043M255 1043L262 1060L272 1079L265 1091L267 1102M255 1043L270 1033L272 1025L275 1007L289 1006L298 1018L309 1017L328 1004M92 772L118 777L136 800L138 810L159 840L178 845L201 850L206 846M206 846L219 859L236 861L244 859L267 891L273 909L283 914L294 915L308 939L300 958L295 959L310 984L316 986L328 1004M206 846L207 828L216 814L234 817L237 804L254 790L249 772M249 772L264 764L285 774L287 776L297 776L331 783L361 786M249 772L240 775L222 758L228 736L263 734L281 724L302 725L307 712L316 699L334 697L313 672L281 643L281 635L281 619L312 612L310 592L316 578M316 578L322 584L343 587L365 591L397 576L404 594L419 599L439 619L445 633M201 455L219 471L249 515L266 520L269 534L291 549L316 578M253 319L269 325L304 352L313 352L354 393L379 400L384 408L432 435L439 446L447 441L459 417L501 434L527 437L537 445";

/** Kommunkod -> [x, y], en punkt inuti respektive kommun. */
export const municipalityPoints: Record<string, readonly [number, number]> = {
  "0114": [396, 1076],
  "0115": [413, 1068],
  "0117": [423, 1077],
  "0120": [433, 1097],
  "0123": [393, 1088],
  "0125": [387, 1096],
  "0126": [405, 1111],
  "0127": [394, 1118],
  "0128": [387, 1109],
  "0136": [412, 1120],
  "0138": [421, 1109],
  "0139": [384, 1074],
  "0140": [368, 1115],
  "0160": [406, 1082],
  "0162": [405, 1089],
  "0163": [398, 1084],
  "0180": [406, 1102],
  "0181": [373, 1130],
  "0182": [414, 1103],
  "0183": [401, 1093],
  "0184": [403, 1094],
  "0186": [412, 1094],
  "0187": [416, 1089],
  "0188": [437, 1040],
  "0191": [395, 1065],
  "0192": [396, 1136],
  "0305": [374, 1063],
  "0319": [366, 958],
  "0330": [393, 1051],
  "0331": [342, 1013],
  "0360": [373, 984],
  "0380": [380, 1029],
  "0381": [351, 1060],
  "0382": [408, 1000],
  "0428": [285, 1129],
  "0461": [354, 1125],
  "0480": [337, 1160],
  "0481": [352, 1170],
  "0482": [331, 1129],
  "0483": [307, 1137],
  "0484": [319, 1100],
  "0486": [346, 1103],
  "0488": [375, 1145],
  "0509": [216, 1228],
  "0512": [247, 1266],
  "0513": [274, 1249],
  "0560": [237, 1231],
  "0561": [296, 1224],
  "0562": [276, 1158],
  "0563": [324, 1227],
  "0580": [267, 1205],
  "0581": [322, 1189],
  "0582": [313, 1201],
  "0583": [241, 1178],
  "0584": [224, 1205],
  "0586": [242, 1212],
  "0604": [220, 1264],
  "0617": [160, 1322],
  "0642": [162, 1255],
  "0643": [174, 1254],
  "0662": [140, 1335],
  "0665": [179, 1309],
  "0680": [176, 1280],
  "0682": [208, 1293],
  "0683": [179, 1342],
  "0684": [208, 1323],
  "0685": [242, 1319],
  "0686": [245, 1292],
  "0687": [222, 1248],
  "0760": [258, 1356],
  "0761": [247, 1387],
  "0763": [226, 1412],
  "0764": [198, 1379],
  "0765": [186, 1406],
  "0767": [148, 1410],
  "0780": [227, 1370],
  "0781": [163, 1381],
  "0821": [288, 1342],
  "0834": [289, 1425],
  "0840": [325, 1413],
  "0860": [278, 1320],
  "0861": [316, 1353],
  "0862": [266, 1404],
  "0880": [304, 1396],
  "0881": [287, 1381],
  "0882": [313, 1318],
  "0883": [311, 1256],
  "0884": [283, 1283],
  "0885": [336, 1377],
  "0980": [437, 1302],
  "1060": [205, 1437],
  "1080": [272, 1440],
  "1081": [245, 1440],
  "1082": [225, 1444],
  "1083": [210, 1466],
  "1214": [116, 1474],
  "1230": [120, 1510],
  "1231": [111, 1511],
  "1233": [106, 1531],
  "1256": [179, 1442],
  "1257": [131, 1434],
  "1260": [106, 1462],
  "1261": [111, 1494],
  "1262": [111, 1502],
  "1263": [121, 1522],
  "1264": [141, 1529],
  "1265": [154, 1510],
  "1266": [153, 1489],
  "1267": [139, 1475],
  "1270": [170, 1520],
  "1272": [201, 1457],
  "1273": [171, 1426],
  "1275": [130, 1449],
  "1276": [122, 1459],
  "1277": [109, 1454],
  "1278": [95, 1426],
  "1280": [108, 1519],
  "1281": [133, 1508],
  "1282": [101, 1481],
  "1283": [95, 1461],
  "1284": [85, 1447],
  "1285": [127, 1488],
  "1286": [157, 1529],
  "1287": [124, 1536],
  "1290": [179, 1472],
  "1291": [185, 1523],
  "1292": [106, 1439],
  "1293": [153, 1449],
  "1315": [133, 1361],
  "1380": [111, 1389],
  "1381": [122, 1415],
  "1382": [99, 1347],
  "1383": [77, 1339],
  "1384": [68, 1314],
  "1401": [70, 1283],
  "1402": [62, 1277],
  "1407": [34, 1277],
  "1415": [52, 1240],
  "1419": [35, 1243],
  "1421": [40, 1225],
  "1427": [21, 1197],
  "1430": [38, 1183],
  "1435": [25, 1161],
  "1438": [53, 1137],
  "1439": [61, 1171],
  "1440": [68, 1249],
  "1441": [73, 1265],
  "1442": [101, 1250],
  "1443": [89, 1279],
  "1444": [94, 1210],
  "1445": [101, 1227],
  "1446": [199, 1177],
  "1447": [183, 1142],
  "1452": [139, 1302],
  "1460": [73, 1125],
  "1461": [79, 1167],
  "1462": [64, 1236],
  "1463": [89, 1309],
  "1465": [116, 1314],
  "1466": [121, 1248],
  "1470": [119, 1222],
  "1471": [143, 1189],
  "1472": [186, 1199],
  "1473": [181, 1176],
  "1480": [51, 1272],
  "1481": [58, 1292],
  "1482": [49, 1256],
  "1484": [29, 1202],
  "1485": [56, 1204],
  "1486": [19, 1135],
  "1487": [72, 1191],
  "1488": [75, 1225],
  "1489": [86, 1257],
  "1490": [111, 1277],
  "1491": [141, 1271],
  "1492": [93, 1131],
  "1493": [162, 1178],
  "1494": [118, 1198],
  "1495": [145, 1205],
  "1496": [168, 1198],
  "1497": [185, 1216],
  "1498": [170, 1233],
  "1499": [143, 1234],
  "1715": [131, 1072],
  "1730": [72, 1048],
  "1737": [124, 977],
  "1760": [189, 1079],
  "1761": [148, 1101],
  "1762": [147, 1045],
  "1763": [147, 1066],
  "1764": [120, 1087],
  "1765": [64, 1088],
  "1766": [124, 1035],
  "1780": [161, 1085],
  "1781": [186, 1106],
  "1782": [185, 1043],
  "1783": [157, 1016],
  "1784": [99, 1061],
  "1785": [101, 1103],
  "1814": [221, 1117],
  "1860": [203, 1145],
  "1861": [248, 1135],
  "1862": [199, 1121],
  "1863": [212, 1049],
  "1864": [231, 1033],
  "1880": [237, 1104],
  "1881": [240, 1123],
  "1882": [232, 1148],
  "1883": [206, 1097],
  "1884": [226, 1080],
  "1885": [246, 1061],
  "1904": [272, 1049],
  "1907": [295, 1053],
  "1960": [294, 1094],
  "1961": [301, 1071],
  "1962": [288, 1018],
  "1980": [316, 1061],
  "1981": [314, 1029],
  "1982": [281, 1032],
  "1983": [286, 1073],
  "1984": [278, 1096],
  "2021": [191, 977],
  "2023": [134, 912],
  "2026": [226, 976],
  "2029": [221, 952],
  "2031": [252, 902],
  "2034": [217, 877],
  "2039": [121, 831],
  "2061": [257, 1017],
  "2062": [191, 922],
  "2080": [284, 942],
  "2081": [252, 977],
  "2082": [270, 985],
  "2083": [294, 988],
  "2084": [308, 1004],
  "2085": [229, 1000],
  "2101": [318, 923],
  "2104": [312, 972],
  "2121": [277, 872],
  "2132": [341, 800],
  "2161": [269, 816],
  "2180": [347, 958],
  "2181": [322, 954],
  "2182": [337, 883],
  "2183": [309, 889],
  "2184": [319, 822],
  "2260": [283, 749],
  "2262": [349, 727],
  "2280": [371, 720],
  "2281": [326, 750],
  "2282": [384, 690],
  "2283": [318, 639],
  "2284": [397, 630],
  "2303": [278, 665],
  "2305": [258, 709],
  "2309": [194, 605],
  "2313": [264, 578],
  "2321": [121, 659],
  "2326": [181, 707],
  "2361": [165, 777],
  "2380": [234, 655],
  "2401": [449, 609],
  "2403": [430, 577],
  "2404": [450, 534],
  "2409": [509, 545],
  "2417": [444, 468],
  "2418": [406, 438],
  "2421": [284, 414],
  "2422": [312, 382],
  "2425": [263, 508],
  "2460": [461, 578],
  "2462": [272, 462],
  "2463": [358, 557],
  "2480": [491, 575],
  "2481": [396, 501],
  "2482": [499, 491],
  "2505": [428, 378],
  "2506": [306, 279],
  "2510": [383, 243],
  "2513": [570, 286],
  "2514": [593, 336],
  "2518": [605, 270],
  "2521": [567, 194],
  "2523": [485, 220],
  "2560": [492, 375],
  "2580": [555, 379],
  "2581": [507, 417],
  "2582": [518, 339],
  "2583": [630, 334],
  "2584": [487, 105],
};
